import React, { useEffect } from "react";
import { useGetTeamsFromGroups } from "../../../../../positionTeams/hooks/useGetTeamsFromGroups";
import './index.css'
import { compareTeams } from "../../../../../positionTeams/utils/orderTeams";

const TableGroup = ({group})=>{
    const idTournament = window.location?.pathname?.split('/')?.[2];
  const { allTeamsByGroup } = useGetTeamsFromGroups({tournamnetId: idTournament})
  
  

    console.log('id', idTournament)
    console.log('allTeams', allTeamsByGroup)

    return(<div style={{ width:'35%'}}>

<table style={{width:'100%'}}>
  <thead style={{padding:'2px'}}>
    <tr>
      <th>EQUIPO</th>
      <th style={{width:'15%', textAlign:'center'}}>PTS</th>
      <th style={{width:'15%', textAlign:'center'}}>DG</th>
    </tr>
  </thead>
  <tbody>
    {
        allTeamsByGroup?.[group]?.sort(compareTeams)?.map(itemInfo =>(
            <tr className="row-table-group">
<td>
    <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <p>{itemInfo?.name}</p>
    <img  width={30} height={30} src={itemInfo?.img} />

    </div>
</td>
                <td style={{width:'15%', textAlign:'center'}}>{itemInfo?.TotalPuntos}</td>
                <td style={{width:'15%', textAlign:'center'}}>{itemInfo?.TotalGolesA - itemInfo?.TotalGolesC}</td>
            </tr>
        ))
    }

  </tbody>

</table>
    </div>)

}

export default TableGroup